import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import clinic from "../config/clinic.json";

const SITE = (process.env.REACT_APP_SITE_URL || clinic.siteUrl || "").replace(/\/$/, "");

type Props = {
  title: string;
  description?: string;
  noIndex?: boolean;
};

export function PageMeta({ title, description, noIndex }: Props) {
  const { pathname } = useLocation();

  useEffect(() => {
    document.title = title;
    const desc = document.querySelector('meta[name="description"]');
    if (desc && description) desc.setAttribute("content", description);

    upsertMeta("property", "og:title", title);
    if (description) upsertMeta("property", "og:description", description);
    upsertMeta("name", "twitter:title", title);
    if (description) upsertMeta("name", "twitter:description", description);

    const canonicalHref = SITE ? `${SITE}${pathname}` : pathname || "/";
    upsertLink("canonical", canonicalHref);
    if (SITE) upsertMeta("property", "og:url", `${SITE}${pathname}`);

    const robots = document.querySelector('meta[name="robots"]');
    if (noIndex) {
      if (robots) robots.setAttribute("content", "noindex, nofollow");
      else {
        const m = document.createElement("meta");
        m.setAttribute("name", "robots");
        m.setAttribute("content", "noindex, nofollow");
        document.head.appendChild(m);
      }
    } else if (robots) {
      robots.setAttribute("content", "index, follow");
    }
  }, [title, description, noIndex, pathname]);

  return null;
}

function upsertMeta(attr: "name" | "property", key: string, value: string) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", value);
}

function upsertLink(rel: string, href: string) {
  let el = document.head.querySelector(`link[rel="${rel}"]`) as HTMLLinkElement | null;
  if (!el) {
    el = document.createElement("link");
    el.rel = rel;
    document.head.appendChild(el);
  }
  el.href = href;
}
